import { useState, useEffect } from 'react';
import getExpandedContent from '../../../../api/contentDeliveryApi.ts';
import { clearLoader } from '../util/clearLoader.ts';
const useExpandedContent = (pageId) => {
    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await getExpandedContent(pageId);
                setResults(response);
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
            finally {
                setLoading(false);
                clearLoader();
            }
        };
        fetchData();
    }, [pageId]);
    return { results, loading };
};
export default useExpandedContent;
